import { AbstractControl, ValidationErrors } from '@angular/forms';

export function PasswordValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!value) {
    return null; // Empty field is valid
  }

  const hasLowercase = /[a-z]/.test(value);
  const hasUppercase = /[A-Z]/.test(value);
  const hasNumber = /\d/.test(value);
  const hasSymbol = /[!@#$%^&*()_+{}\[\]:;<>,.?~-]/.test(value);

  const passwordCriteriaMet =
    [hasLowercase, hasUppercase, hasNumber, hasSymbol].filter(Boolean).length >= 3;

  if (value.length < 8 || value.length > 64 || !passwordCriteriaMet) {
    return {
      passwordInvalid: true, // Custom error key
    };
  }

  return null;
}
